import { render, staticRenderFns } from "./Pessoa.vue?vue&type=template&id=1d261ed4&scoped=true&lang=pug"
import script from "./Pessoa.vue?vue&type=script&lang=js"
export * from "./Pessoa.vue?vue&type=script&lang=js"
import style0 from "./Pessoa.vue?vue&type=style&index=0&id=1d261ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d261ed4",
  null
  
)

export default component.exports